import AppInfo from "./AppInfo";

//Hide payment information in native apps that don't allow another payment provider, ie Apple, Android
const Payment = (props) => {
    const paymentAllowed = AppInfo.allowPaymentManagement()
    const hidden = !paymentAllowed
    return !hidden && <div>{props.children}</div>;
}

export default Payment;